import { render } from "./SolvedProblemsChart.vue?vue&type=template&id=19ecb4b0&scoped=true&ts=true"
import script from "./SolvedProblemsChart.vue?vue&type=script&lang=ts"
export * from "./SolvedProblemsChart.vue?vue&type=script&lang=ts"

import "./SolvedProblemsChart.vue?vue&type=style&index=0&id=19ecb4b0&lang=postcss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ecb4b0"]])

export default __exports__